import React, {useMemo} from 'react';
import './styles.css';

const ProgressBar = ({progress, total}) => {
  const percentage = useMemo(() => ((progress / total) * 100).toFixed(2), [progress, total]);

  return (
    <div className="progress-bar" style={{'--progress': `${percentage || 0}%`}}>
      <div className="progress-bar__progress" />
    </div>
  );
};

export default ProgressBar;
